import React from 'react';
import { Grid, Stack, CircularProgress } from '@mui/material';
import { useSelector } from 'react-redux';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { portalConfigurationsSelectors } from 'redux/portalConfigurationReducer';
import { PortalConfigurationType } from '@trnsact/trnsact-shared-types';
import { PortalConfiguration, PortalConfigurationRenderProps } from '../../types';
import { RenderWithFallback } from 'components/shared/Conditional/RenderWithFallback';
import { SendApplicationForm } from './SendApplicationForm';
import { accountSelectors } from 'redux/accountReducer';
import { useQuery } from '@apollo/client';
import { LenderProfilesWithOcaAccessResponse, LenderProfilesWithOcaAccessVariables } from 'types';
import { GET_LENDER_PROFILES_WITH_OCA_ACCESS } from 'queries/common';
import { getConfigToSave, getLenderProfilesWithOcaOptions } from '../lib';
import { SendApplicationPortalConfig, SendApplicationPortalConfigFormValues } from '../types';

export const SendApplicationManagement = ({ loading, onSaveConfiguration }: PortalConfigurationRenderProps) => {
  const account = useSelector(accountSelectors.account);
  const portalConfiguration = useSelector((state: any) =>
    portalConfigurationsSelectors.configDataByType(state, PortalConfigurationType.SendApplication)
  ) as PortalConfiguration<SendApplicationPortalConfig>;

  const { data, loading: isLenderProfilesWithOcaAccessLoading } = useQuery<
    LenderProfilesWithOcaAccessResponse,
    LenderProfilesWithOcaAccessVariables
  >(GET_LENDER_PROFILES_WITH_OCA_ACCESS, {
    skip: !account?.id,
    variables: { accountId: account.id },
  });

  const handleSave = async (formData: SendApplicationPortalConfigFormValues) => {
    const configToSave = getConfigToSave(portalConfiguration, formData);
    await onSaveConfiguration(configToSave);
  };

  const lenderProfilesWithOcaOptions = getLenderProfilesWithOcaOptions(data?.lenderProfilesWithOcaAccess?.data ?? []);

  if (!lenderProfilesWithOcaOptions.length) {
    return null;
  }

  return (
    <Grid item sm={12} md={6}>
      <CardContainer title="Send Application Settings">
        <RenderWithFallback
          isLoading={!portalConfiguration || isLenderProfilesWithOcaAccessLoading}
          fallBack={
            <Stack alignItems="center" justifyContent="center" height="100%">
              <CircularProgress />
            </Stack>
          }
        >
          <SendApplicationForm
            isLoading={loading}
            onConfirm={handleSave}
            portalConfigurationConfig={portalConfiguration?.jsonDefinition?.config}
            lenderProfilesWithOcaOptions={lenderProfilesWithOcaOptions}
          />
        </RenderWithFallback>
      </CardContainer>
    </Grid>
  );
};
